/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesLocationCities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Location Cities Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, July 07, 2019 - 04:35:28 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/07/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const LocationCityList = Loadable({
    loader: () => import('../containers/LocationCities/LocationCityListContainer'),
    loading: Loading,
});

export const LocationCityForm = Loadable({
    loader: () => import('../containers/LocationCities/LocationCityEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesLocationCities.js